import { render } from "./popup.vue?vue&type=template&id=4194bd1a"
import script from "./popup.vue?vue&type=script&lang=ts"
export * from "./popup.vue?vue&type=script&lang=ts"
script.render = render

export default script